module.exports = __webpack_public_path__ + "static/media/ETICA_SOSTENIBILIDAD.48e2dc94.png";